import * as t from "./types";
import * as actions from "./action";

/* Logstash */
export const getLogstashPipelinesAction = (
  payload: t.GetLogstashPipelinesRequestType
): t.GetLogstashPipelinesActionType => {
  return {
    type: actions.GET_LOGSTASH_PIPELINES,
    payload,
  };
};

export const getLogstashPipelineStatsAction = (
  payload: t.GetLogstashPipelineStatsRequestType
): t.GetLogstashPipelineStatsActionType => {
  return {
    type: actions.GET_LOGSTASH_PIPELINE_STATS,
    payload,
  };
};
